function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-check-circle",
  "data-name": "Icon feather-check-circle",
  transform: "translate(9.018 9.106)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_112",
  "data-name": "Path 112",
  d: "M182.978,84.756v8.279a89.989,89.989,0,1,1-53.363-82.25",
  transform: "translate(-3 -2.99)",
  fill: "none",
  stroke: "#01F2B4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 18
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_113",
  "data-name": "Path 113",
  d: "M130.485,6,40.5,96.079l-27-27",
  transform: "translate(49.492 12.054)",
  fill: "none",
  stroke: "#01F2B4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 18
}));

function SvgThankyou(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201.724,
    height: 198.222,
    viewBox: "0 0 201.724 198.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyou);
export default __webpack_public_path__ + "static/media/thankyou.1abe592284e515858ddbdad335a485d5.svg";
export { ForwardRef as ReactComponent };